// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-lens-image-type-switcher[data-v-63bcc526]{appearance:none;background-color:transparent;border-style:none;outline:none;padding:0}.contact-lens-image-type-switcher[data-v-63bcc526]:hover{cursor:pointer}.icon[data-v-63bcc526]{height:4rem}", ""]);
// Exports
module.exports = exports;
